import axios from "axios";
import { ReactSelectOptions } from "../components/types";
const radarAxios = axios.create({
  headers: {
    Authorization: "prj_test_pk_02917859217bdc3ee31d9b0d20d3e05d5ed14055",
  },
  baseURL: "https://api.radar.io/v1/search/autocomplete",
});

const onLoadAddress = async (query: string): Promise<ReactSelectOptions> => {
  try {
    const res = await radarAxios.get(`?query=${query}&countryCode=US`);
    return res.data.addresses.map((entry: any) => {
      return {
        label: entry.formattedAddress,
        value: JSON.stringify(entry),
      };
    });
  } catch {
    return [];
  }
};

export default onLoadAddress;
